import { getData } from 'src/api/apiGet';
import { USER_INFO_STATE_PREFERENCE } from 'src/config';

export const getStatusForProvideData = async (chatId: string) => {
  return await getData(USER_INFO_STATE_PREFERENCE, { ['chatId']: chatId });
};
